import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import { AnimatePresence, motion } from "framer-motion";
import HomePage from "./pages/HomePage";
import GoingMerryPage from "./pages/GoingMerryPage";
import ICEPage from "./pages/ICEPage";
import RamseyPage from "./pages/RamseyPage";
import { RAMSEY_ENABLED } from "./config/features";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import AuthPage from "./pages/AuthPage";
import DownloadPage from "./pages/DownloadPage";
import ProfilePage from "./pages/ProfilePage";
import Header from "./components/Header";
import NoticeBanner from "./components/NoticeBanner";
import ChatConsent from "./components/ChatConsent";
import ScrollToTop from "./components/ScrollToTop";
import { StoryProvider } from "./context/StoryContext";
import { ScrollProvider } from "./context/ScrollContext";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
        className="flex-grow flex flex-col"
      >
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/goingmerry" element={<GoingMerryPage />} />
          <Route path="/ice" element={<ICEPage />} />
          <Route path="/ramsey" element={RAMSEY_ENABLED ? <RamseyPage /> : <Navigate to="/" replace />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <Authenticator.Provider>
      <Router>
        <StoryProvider>
          <ScrollProvider>
            <ScrollToTop />
            <div className="bg-[#191d2b] min-h-screen flex flex-col overflow-x-hidden">
              <NoticeBanner />
              <ChatConsent />
              <Header />
              <AnimatedRoutes />
            </div>
          </ScrollProvider>
        </StoryProvider>
      </Router>
    </Authenticator.Provider>
  );
}
